import React, { Component } from "react";
import { DOCUMENT_TYPE, RULE_TYPES, RULE_TYPE } from "utils/constants";
import {
    FindByEmployeeRoleAction,
    OrganisationChartAction,
    ProjectManagerAction,
    CostUnitsAction,
    DepartmentManagerAction,
    ListOfApproversAction,
    ProjectRoleAction,
} from "./StepActions.component";

import {
    getEnabledFeaturesForDocumentType,
    setStepAction,
    setStepCondition,
    setStepConditionByNumber,
} from "./workflowdetails.action";
import * as reduxSelectors from "../store/application.reducers";
import { connect } from "react-redux";

import AmountCondition from "./AmountCondition.Component";
import { DaysCondition } from "./DaysCondition.Component";
import { Button, ButtonType } from "components/common/Button.component";
import { Trash2Icon } from "lucide-react";
import { DropdownSelect } from "components/common/dropdown/DropdownSelect.component";
import { DropdownPosition, DropdownSelectTypes } from "types/gaiaComponents/dropdownButton.types";
import { ICON_SIZE } from "components/common/constants";

//map the action component to the rule types - we should cover all the RULE_TYPES .. key from constants.js
//TODO discuss this with Alban, maybe this is not the brightest solution :)
const COMPONENT_TYPE = {
    BY_EMPLOYEE: FindByEmployeeRoleAction,
    BY_LIST: ListOfApproversAction,
    BY_PROJECT_MANAGER: ProjectManagerAction,
    BY_DEPARTMENT_MANAGER: DepartmentManagerAction,
    BY_COST_UNITS: CostUnitsAction,
    BY_ORGANISATION_CHART: OrganisationChartAction,
    BY_GENERAL_APPROVER: ProjectRoleAction,
};

export class StepRule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedRuleType: props.action ? RULE_TYPES[props.action.xtype].translationKey : null,
        };
        this.selectRuleType = this.selectRuleType.bind(this);
        this.changeAmountCondition = this.changeAmountCondition.bind(this);
        this.deleteStepRule = this.deleteStepRule.bind(this);
        this.addRule = this.addRule.bind(this);
    }

    selectRuleType(value) {
        if (RULE_TYPES[value].translationKey !== this.state.selectedRuleType) {
            this.setState({
                selectedRuleType: RULE_TYPES[value].translationKey,
            });

            let action = {
                actionType: value,
                xtype: value,
            };

            let isRuleComplete = (value === RULE_TYPE.BY_PROJECT_MANAGER || value === RULE_TYPE.BY_DEPARTMENT_MANAGER || value === RULE_TYPE.BY_NEAREST_MANAGER);

            this.props.setStepAction(this.props.idStep, this.props.idRule, action, this.props.stepNumber, this.props.ruleNumber, isRuleComplete);
        }
    }

    changeAmountCondition(amount, isComplete = true) {
        if (this.props.idRule !== null && typeof this.props.idRule !== "undefined" && this.props.idStep !== null && typeof this.props.idStep !== "undefined") {
            this.props.setStepCondition(this.props.idStep, this.props.idRule, amount, isComplete);
        } else {
            this.props.setStepConditionByNumber(this.props.stepNumber, this.props.ruleNumber, amount, isComplete);
        }
    }

    componentDidMount() {
        this.props.getEnabledFeaturesForDocumentType(this.props.type,this.props.currentContextId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.action !== this.props.action) {
            this.setState({
                selectedRuleType: this.props.action ? RULE_TYPES[this.props.action.xtype].translationKey : null,
            });
        }
    }

    deleteStepRule() {
        this.props.deleteStepRule(this.props.idRule);
    }

    addRule() {
        this.props.addRule(this.props.idStep);
    }

    render() {
        let { type, translate, action} = this.props;
        let ComponentName = this.state.selectedRuleType ? COMPONENT_TYPE[this.state.selectedRuleType] : null;

        const actions = this.props.features[this.props.type] ? this.props.features[this.props.type].actions : [];

        const menuItems = actions
            .filter((item) => {
                return item !== "Visma.Approval.Rules.FindByRoleActionWithRequester";
            })
            .map((action) => {
                return {
                    key: action,
                    text: RULE_TYPES[action] ? translate("workflowDetails.rule." + RULE_TYPES[action].translationKey) : translate("workflowDetails.rule.unknown"),
                    onClick: () => this.selectRuleType(action),
                    disabled: false,
                    selected: this.state.selectedRuleType && RULE_TYPES[action] && RULE_TYPES[action].translationKey === this.state.selectedRuleType
                };
            });

        const currentValue = this.state.selectedRuleType
            ? translate("workflowDetails.rule." + this.state.selectedRuleType)
            : "";

        return (
            <div className="rule-area">
                <h4 className="no-border mb-3 d-flex flex-row align-items-center">
                    <strong>
                        {translate("workflowDetails.ruleName", this.props.index + 1)}
                    </strong>
                    <span className="mx-3">
                        {translate("workflowDetails.approve", translate("documentTypes." + DOCUMENT_TYPE.asString(type)))}
                    </span>
                    <Button type={ButtonType.GHOST}
                            iconOnly={true}
                            icon={<Trash2Icon size={ICON_SIZE.MEDIUM}/>}
                            extraClassName={"ms-auto"}
                            disabled={!this.props.canDelete}
                            onClick={this.deleteStepRule}
                            tooltip={{
                                id: `step-rule-delete-tooltip-${this.props.stepNumber}-${this.props.idRule || this.props.ruleNumber || this.props.index}`,
                                content: () => translate("workflowDetails.deleteRule")
                            }}
                    />
                </h4>

                <div className="d-flex gap-8">
                    <div className="no-side-padding margin-right" id="Rule_Type_Selection">
                        <DropdownSelect
                            id="rule_type"
                            type={DropdownSelectTypes.VALUE}
                            position={DropdownPosition.BOTTOM_LEFT}
                            value={currentValue}
                            items={menuItems}
                            isEmpty={menuItems.length === 0}
                        />
                    </div>
                    {ComponentName &&
                        <div className="component">
                            <ComponentName type={type}
                                           action={action}
                                           componentType={RULE_TYPE[this.state.selectedRuleType]}
                                           idStep={this.props.idStep}
                                           idRule={this.props.idRule}
                                           ruleNumber={this.props.ruleNumber}
                                           stepNumber={this.props.stepNumber}
                                           companyUserMap={this.props.companyUserMap}
                                           translate={translate} />
                        </div>
                    }
                </div>


                {this.props.type === DOCUMENT_TYPE.LEAVE_REQUEST ?
                    <DaysCondition translate={this.props.translate}
                                   condition={this.props.condition}
                                   changeAmountCondition={this.changeAmountCondition}
                                   stepNumber={this.props.stepNumber}
                                   ruleNumber={this.props.ruleNumber}
                                   idRule={this.props.idRule} /> :
                    <AmountCondition translate={this.props.translate}
                                     condition={this.props.condition}
                                     changeAmountCondition={this.changeAmountCondition}
                                     stepNumber={this.props.stepNumber}
                                     ruleNumber={this.props.ruleNumber}
                                     idRule={this.props.idRule} />}

                {this.props.addRule &&
                    <div>
                        <hr />
                            <Button type={ButtonType.SECONDARY}
                                    onClick={this.addRule}
                                    text={this.props.translate("workflowDetails.addNewRule")}
                            />
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = function(store) {
    return {
        workflowChanged: reduxSelectors.getWorkflowChangedStatus(store),
        features: store.workflowDetails.features,
        currentContextId: reduxSelectors.getUsersCurrentContextId(store),
    };
};

const connected = connect(mapStateToProps, {
    setStepAction,
    getEnabledFeaturesForDocumentType,
    setStepCondition,
    setStepConditionByNumber,
})(StepRule);
export default connected;
